'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _words = require('lodash/words');

var _words2 = _interopRequireDefault(_words);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var parseClasses = function parseClasses(className, classes, setClasses, stylesheet) {
  var classesArr = typeof classes === 'string' ? (0, _words2.default)(classes, /[^ ]+/g) : (0, _utils.objectToArray)(classes);

  var addClasses = classesArr.concat((0, _utils.objectToArray)(setClasses)).map(function (value) {
    return stylesheet[value] || value;
  }).join(' ');

  if (className && addClasses) {
    return className + ' ' + addClasses;
  } else {
    return className || addClasses;
  }
};

var linkClasses = function linkClasses(element) {
  var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var elementIsFrozen = false;
  var elementShallowCopy = element;

  if (Object.isFrozen && Object.isFrozen(elementShallowCopy)) {
    elementIsFrozen = true;
    elementShallowCopy = (0, _utils.objectUnfreeze)(elementShallowCopy);
    elementShallowCopy.props = (0, _utils.objectUnfreeze)(elementShallowCopy.props);
  }

  var children = elementShallowCopy.props.children;

  if (_react2.default.isValidElement(children)) {
    elementShallowCopy.props.children = linkClasses(_react2.default.Children.only(children), classes);
  } else if ((0, _isArray2.default)(children) || (0, _utils.isIterable)(children)) {
    elementShallowCopy.props.children = _react2.default.Children.map(children, function (node) {
      return _react2.default.isValidElement(node) ? linkClasses(node, classes) : node;
    });
  }

  if (elementShallowCopy.props.classes || elementShallowCopy.props.setClasses) {
    var className = parseClasses(elementShallowCopy.props.className, elementShallowCopy.props.classes, elementShallowCopy.props.setClasses, classes);

    if (className) {
      elementShallowCopy.props.className = className;
    }
  }

  delete elementShallowCopy.props.classes;
  delete elementShallowCopy.props.setClasses;

  if (elementIsFrozen) {
    Object.freeze(elementShallowCopy.props);
    Object.freeze(elementShallowCopy);
  }

  return elementShallowCopy;
};

var renderComponent = function renderComponent(renderedComponent, classes) {
  return (0, _isObject2.default)(renderedComponent) ? linkClasses(renderedComponent, classes) : renderedComponent;
};

exports.default = function () {
  return function (Component) {
    var ClassedComponent = void 0;

    if (Component.prototype.render) {
      ClassedComponent = function (_Component) {
        _inherits(ClassedComponent, _Component);

        function ClassedComponent() {
          _classCallCheck(this, ClassedComponent);

          return _possibleConstructorReturn(this, _Component.apply(this, arguments));
        }

        ClassedComponent.prototype.render = function render() {
          return renderComponent(_Component.prototype.render.call(this), Component.classes);
        };

        return ClassedComponent;
      }(Component);
    } else {
      ClassedComponent = function ClassedComponent() {
        return renderComponent(Component.apply(undefined, arguments), Component.classes);
      };
    }

    var displayName = Component.displayName || Component.name || 'Component';
    ClassedComponent.displayName = displayName;

    return Object.assign(ClassedComponent, Component);
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-react/lib/applyClasses.js
// module id = 545
// module chunks = 0